import React from "react";
import { ElementInstance } from "@/3d/element/Element";
import { useResourcesState } from "@/state/resourcesState";
import { MeshMaterials } from "@/3d/material/MeshMaterials";
import { ModelInstance } from "@/3d/modelInstance/ModelInstance";
type ElementInstanceRendererProps = {
    instance: ElementInstance;
    model: ModelInstance;
    renderArea?: boolean;
};

export const ElementInstanceRenderer: React.FC<ElementInstanceRendererProps> = ({
    instance,
    model,
    renderArea = false,
}) => {
    const { materials } = useResourcesState();

    return (
        <group position={instance.area.box.center}>
            {renderArea && (
                <mesh>
                    <boxGeometry
                        args={[
                            instance.area.box.sizeX,
                            instance.area.box.sizeY,
                            instance.area.box.sizeZ,
                        ]}
                    />
                    <meshBasicMaterial color="yellow" wireframe={true} />
                </mesh>
            )}
            <mesh geometry={instance.geometry}>
                <MeshMaterials
                    model={model}
                    instance={instance}
                    materials={materials}
                    isSelected={false}
                />
            </mesh>
        </group>
    );
};
